import React from 'react';
import { og } from '../../utils/utils';

const Meta = ({ title, description, image }) => {
  const url = `${window.location.pathname}?og=${og({ title, description, image })}`;
  return <a id="meta:og" href={url} />;
};

export default Meta;
